<template>
    <rkm-row>
        <rkm-col cols="12">

            <rkm-form-checkbox v-model="data.model.exibirExameAmbulatorioAtendimento">
                Se ativo, exibirá a mensagem para agendar os exames solicitados no atendimento do ambulatório.
            </rkm-form-checkbox>
        </rkm-col>
    </rkm-row>
</template>

<script>

export default {
    props: {
        data: { type: Object, required: true },
    },
}
</script>